import styled from "styled-components"
import {
  ActiveCategoryStyles,
  DropdownStyles,
  DropdownWrapperStyles,
} from "./categories-dropdown-styles"
import { BreakPoints, media } from "../../../helpers/rwd"
import { colors } from "../../../helpers/colors"

export const DropdownWrapper = styled.div`
  display: flex;
  height: 60px;
  position: relative;
  ${media.min(BreakPoints.phone)} {
    display: none;
  }
  ${DropdownWrapperStyles}
`

export const ActiveCategory = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 10px;
  ${ActiveCategoryStyles}
`

export const Dropdown = styled.div`
  position: absolute;
  min-width: 100px;
  top: 100%;
  z-index: 10;
  padding: 10px 20px;
  background: ${colors.white};
  & > a {
    padding: 15px 0;
  }
  ${DropdownStyles};
`
